/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-24 08:54:18
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-03-10 12:51:25
 * @FilePath: /wemeet-web-activity/src/pages/questions/type/questionType.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

/**
 * RADIO, // 单选
  CHECKBOX, // 多选
  INPUT, // 单行输入
  TEXTAREA, // 多行输入
  PHONE, // 手机号
 */
export let AnswerType = /*#__PURE__*/function (AnswerType) {
  AnswerType[AnswerType["NONE"] = 0] = "NONE";
  AnswerType[AnswerType["INPUT"] = 1] = "INPUT";
  AnswerType[AnswerType["TEXTAREA"] = 2] = "TEXTAREA";
  AnswerType[AnswerType["RADIO"] = 3] = "RADIO";
  AnswerType[AnswerType["CHECKBOX"] = 4] = "CHECKBOX";
  return AnswerType;
}({}); // 多选
export let QuestionType = /*#__PURE__*/function (QuestionType) {
  QuestionType[QuestionType["NONE"] = 0] = "NONE";
  QuestionType[QuestionType["CUSTOMIZE"] = 1] = "CUSTOMIZE";
  QuestionType[QuestionType["PHONE"] = 2] = "PHONE";
  QuestionType[QuestionType["NO_USE"] = 3] = "NO_USE";
  QuestionType[QuestionType["NAME"] = 4] = "NAME";
  QuestionType[QuestionType["EMAIL"] = 5] = "EMAIL";
  return QuestionType;
}({}); // 邮箱

/**
 * REQUIRED, // 必填
  NO_REQUIRED, // 非必填
 */
export let IsRequired = /*#__PURE__*/function (IsRequired) {
  IsRequired[IsRequired["NONE"] = 0] = "NONE";
  IsRequired[IsRequired["REQUIRED"] = 1] = "REQUIRED";
  IsRequired[IsRequired["NO_REQUIRED"] = 2] = "NO_REQUIRED";
  return IsRequired;
}({}); // 非必填